
  <p-fileUpload 
              name="media"
              customUpload="true"
              #fileUpload
              (onUpload)="onUpload($event)"
              (uploadHandler)="uploadFile($event)"
              (onSelect)="onFileSelect($event)"
              [multiple]="false"
              [accept]="attribute.attributeType === 'MEDIA' ? '.jpg, .jpeg, .png' : '.pdf'"
              maxFileSize="1000000"
              [chooseLabel]="'Choose' | translate"
              [uploadLabel]="'Upload' | translate"
              [cancelLabel]="'Cancel' | translate">
              <!-- <ng-template pTemplate="content">
                <ul *ngIf="uploadedFiles.length">
                  <li *ngFor="let file of uploadedFiles">
                    {{ file.name }} - {{ file.size }} bytes
                  </li>
                </ul>
              </ng-template> -->
  </p-fileUpload>
  <button
          pButton
          type="button"
          [label]="attribute.attributeType === 'PDF'?  ('buttons.deleteFile'| translate) : ('buttons.deleteMedia' | translate)"
          icon="pi pi-trash"
          (click)="deleteMedia()"
          [disabled]="showSpinner"
          severity="danger"
          class="mr-2 mt-5"></button>
  @if(showSpinner) {
    <div class="flex justify-content-center">
      <p-progressSpinner 
          styleClass="w-4rem h-4rem" 
          strokeWidth="8" 
          animationDuration=".5s" />
  </div>
  }


